import React, { useRef, useEffect } from "react";
import { Box, Button } from "@mui/material";

const CustomTabBar = ({ tabs, activeIndex, onChange }) => {
  const tabRefs = useRef([]);

  useEffect(() => {
    if (tabRefs.current[activeIndex]) {
      tabRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        inline: "start",
      });
    }
  }, [activeIndex]);

  return (
    <Box
      sx={{
        display: "flex",
        overflowX: "auto",
        whiteSpace: "nowrap",
        gap: 1,
        py: 1,
        px: 1.5,
        borderRadius: "40px",
        bgcolor: "rgb(180, 180, 180)",
        boxShadow: "inset 0 0 0 1pxrgb(171, 171, 171)",
      }}
    >
      {tabs.map((label, i) => (
        <Button
          key={label}
          ref={(el) => (tabRefs.current[i] = el)}
          onClick={() => onChange(i)}
          variant="contained"
          disableElevation
          sx={{
            margin: { xs: activeIndex === 0 ? "0 0 0 0" : "0 0 0 6px", md: 0 },
            borderRadius: "40px",
            px: 3,
            py: 1,
            minWidth: "max-content",
            textTransform: "none",
            fontWeight: 500,
            bgcolor: i === activeIndex ? "white" : "transparent",
            color: i === activeIndex ? "black" : "#333",
            boxShadow:
              i === activeIndex ? "0px 2px 8px rgba(0, 0, 0, 0.15)" : "none",
            transition: "all 0.2s",
            "&:hover": {
              bgcolor: i === activeIndex ? "white" : "rgb(228, 228, 228)",
            },
          }}
        >
          {label}
        </Button>
      ))}
    </Box>
  );
};

export default CustomTabBar;
